<template>
  <div>
    <!--    <b-button-->
    <!--      variant="flat-secondary"-->
    <!--      class="mb-1"-->
    <!--      to="/"-->
    <!--    >-->
    <!--      <feather-icon-->
    <!--        size="16"-->
    <!--        icon="ArrowLeftIcon"-->
    <!--        class="mr-50"-->
    <!--      />-->
    <!--      Back to Home-->
    <!--    </b-button>-->

    <b-tabs
      v-if="$device.mobile && hasUserData"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      class="nav-profile"
      nav-class="nav-left"
    >
      <!-- general tab -->
      <b-tab
        v-if="!hasStepGuide"
        :active="tab === 'business-information'"
        @click="handleUrlTab('business-information')"
      >
        <!-- title -->
        <template #title>
          <span class="font-medium">{{ $t("profile.textGeneral") }}</span>
        </template>

        <b-card class="card-content">
          <b-tabs
            v-if="isVerifyContractEnabled"
            v-model="activeSubTab"
            class="general-sub-tabs"
          >
            <!-- Account Information Tab -->
            <b-tab>
              <template #title>
                <span class="font-medium">Thông tin tài khoản</span>
              </template>
              <general />
            </b-tab>
            <!--/ Account Information Tab -->
            <!-- Customer Information Tab -->
            <b-tab>
              <template #title>
                <span class="font-medium">Thông tin khách hàng</span>
              </template>
              <customer-information
                v-if="contractData"
                :contract-data="contractData"
                :options="contractOptions"
              />
              <div
                v-else
                class="no-contract-message"
              >
                <p>Chưa có thông tin hợp đồng</p>
              </div>
            </b-tab>
            <!--/ Customer Information Tab -->
          </b-tabs>
          <div v-else>
            <div class="mb-2 font-20 font-medium">
              {{ $t('profile.textGeneral') }}
            </div>
            <general />
          </div>
        </b-card>
      </b-tab>
      <!--/ general tab -->

      <!-- change password tab -->
      <b-tab
        :active="tab === 'change-password'"
        @click="handleUrlTab('change-password')"
      >
        <template #title>
          <span class="font-medium">{{
            $t("profile.textChangePassword")
          }}</span>
        </template>

        <b-card><change-password /></b-card>
      </b-tab>
      <!--/ change password tab -->

      <!-- add gift code -->
      <b-tab
        v-if="isMember && !hasStepGuide"
        :active="tab === 'gift-code'"
        @click="handleUrlTab('gift-code')"
      >
        <template #title>
          <span class="font-medium">{{
            $t("profile.textRedeemGiftCode")
          }}</span>
        </template>

        <div>
          <redeem-gift-code />
        </div>
      </b-tab>
      <!--/ add gift code -->
    </b-tabs>
    <b-tabs
      v-else-if="hasUserData"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      class="nav-profile"
      end
      nav-class="nav-left"
    >
      <!-- general tab -->
      <b-tab
        v-if="!hasStepGuide"
        :active="tab === 'business-information'"
        @click="handleUrlTab('business-information')"
      >
        <!-- title -->
        <template #title>
          <span class="font-medium">{{ $t("profile.textGeneral") }}</span>
        </template>

        <b-card class="card-content">
          <b-tabs
            v-if="isVerifyContractEnabled"
            v-model="activeSubTab"
            class="general-sub-tabs"
          >
            <!-- Account Information Tab -->
            <b-tab>
              <template #title>
                <span class="font-medium">Thông tin tài khoản</span>
              </template>
              <general />
            </b-tab>
            <!--/ Account Information Tab -->
            <!-- Customer Information Tab -->
            <b-tab>
              <template #title>
                <span class="font-medium">Thông tin khách hàng</span>
              </template>
              <customer-information
                v-if="contractData"
                :contract-data="contractData"
                :options="contractOptions"
              />
              <div
                v-else
                class="no-contract-message"
              >
                <p>Chưa có thông tin hợp đồng</p>
              </div>
            </b-tab>
            <!--/ Customer Information Tab -->
          </b-tabs>
          <div v-else>
            <div class="mb-2 font-20 font-medium">
              {{ $t('profile.textGeneral') }}
            </div>
            <general />
          </div>
        </b-card>
      </b-tab>
      <!--/ general tab -->

      <!-- change password tab -->
      <b-tab
        :active="tab === 'change-password'"
        @click="handleUrlTab('change-password')"
      >
        <template #title>
          <span class="font-medium">{{ $t("profile.textChangePassword") }}</span>
        </template>

        <b-card class="card-content">
          <change-password />
        </b-card>
      </b-tab>
      <!--/ change password tab -->

      <!-- add gift code -->
      <b-tab
        v-if="isMember && !hasStepGuide && !isAdreachPlatform"
        :active="tab === 'gift-code'"
        @click="handleUrlTab('gift-code')"
      >
        <template #title>
          <span class="font-medium">{{
            $t("profile.textRedeemGiftCode")
          }}</span>
        </template>

        <div>
          <redeem-gift-code />
        </div>
      </b-tab>
      <!--/ add gift code -->

    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab, BCard,
  // BButton,
} from 'bootstrap-vue'
import { CUSTOMER_TYPE_OPTIONS, CUSTOMER_TYPE } from '@/constants/customerType'
import { ID_TYPE_OPTIONS_INDIVIDUAL, ID_TYPE_OPTIONS_BUSINESS, GENDER_OPTIONS } from '@/constants/contractVerification'
import partnerMixin from '@/mixins/partnerMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import envMixin from '@/mixins/envMixin'
import { createNamespacedHelpers } from 'vuex'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import ChangePassword from './components/ChangePassword.vue'
import General from './components/General.vue'
import RedeemGiftCode from './components/RedeemGiftCode.vue'
import CustomerInformation from './components/CustomerInformation.vue'

const { mapGetters } = createNamespacedHelpers('auth')
const {
  mapGetters: mapGettersContract,
  mapActions: mapActionsContract,
} = createNamespacedHelpers('contract')
export default {
  components: {
    BTabs,
    BTab,
    BCard,
    // BButton,
    // components
    General,
    ChangePassword,
    RedeemGiftCode,
    CustomerInformation,
  },
  mixins: [partnerMixin, stepGuideMixin, envMixin, generalConfigsMixin],
  data() {
    return {
      tab: this.$route.query.tab || 'business-information',
      activeSubTab: 0,
    }
  },
  computed: {
    ...mapGetters(['user']),

    ...mapGettersContract({
      contract: 'contract',
      provincesOptions: 'provincesOptions',
      wardsOptions: 'wardsOptions',
    }),

    hasUserData() {
      return Object.keys(this.user.data).length > 0
    },

    contractData() {
      return this.contract?.customer || this.contract?.customerInfo || null
    },

    contractOptions() {
      return {
        customerType: CUSTOMER_TYPE_OPTIONS.map(option => ({
          label: this.$t(option.labelKey),
          value: option.value,
        })),
        idType: this.getCurrentIdTypeOptions(),
        gender: GENDER_OPTIONS.map(option => ({
          text: this.$t(option.textKey),
          value: option.value,
        })),
        province: this.provincesOptions,
        district: [],
        ward: this.wardsOptions,
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.tab = val?.query?.tab || 'business-information'
      },
    },
    contract: {
      async handler() {
        // Contract data changed, load wards if province code exists
        if (this.contractData && this.contractData.contactInfo) {
          const provinceCode = this.contractData.contactInfo.city?.code || this.contractData.contactInfo.province?.code
          if (provinceCode) {
            await this.getWards(provinceCode)
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActionsContract(['getWards']),

    getCurrentIdTypeOptions() {
      if (!this.contractData?.identityInfo?.customerType) {
        return ID_TYPE_OPTIONS_INDIVIDUAL.map(option => ({
          label: this.$t(option.labelKey),
          value: option.value,
        }))
      }
      const customerType = String(this.contractData.identityInfo.customerType)
      if (customerType === CUSTOMER_TYPE.BUSINESS || customerType === CUSTOMER_TYPE.HOUSEHOLD) {
        return ID_TYPE_OPTIONS_BUSINESS.map(option => ({
          label: this.$t(option.labelKey),
          value: option.value,
        }))
      }
      return ID_TYPE_OPTIONS_INDIVIDUAL.map(option => ({
        label: this.$t(option.labelKey),
        value: option.value,
      }))
    },

    handleUrlTab(tab) {
      this.tab = tab
      this.$router.push(`profile?tab=${tab}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-back {
  margin-bottom: 24px;
  width: max-content;

  .card-text {
    cursor: pointer;

    .icon {
      margin-right: 15px;
    }
  }
}

.card-content {
  border-radius: var(--border-radius-lg);
  box-shadow: none;

  .card-body {
    padding: 32px;

    @media (max-width: 767px) {
      padding: 20px;
  }
  }
}
</style>

<style lang="scss">
.nav-profile {

  .nav-left{

    .nav-item{
      .nav-link{
        color: #16213EB2;
      }
      .nav-link.active{
        color: #16213E ;
        background: none;
        border-left: 3px solid #16213E;
        border-radius: 0;
      }
    }
  }
}

.general-sub-tabs {
  ::v-deep .nav-tabs {
    border-bottom: 1px solid #e0e0e5;
    margin-bottom: 24px;

    .nav-item {
      .nav-link {
        color: #16213EB2;
        border: none;
        padding: 12px 24px;
        font-weight: 500;

        &.active {
          color: #16213E;
          background: none;
          border-bottom: 2px solid #16213E;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
